import { render, staticRenderFns } from "./Tokenomics.vue?vue&type=template&id=a22eb0bc&scoped=true&"
import script from "./Tokenomics.vue?vue&type=script&lang=js&"
export * from "./Tokenomics.vue?vue&type=script&lang=js&"
import style0 from "./Tokenomics.vue?vue&type=style&index=0&id=a22eb0bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22eb0bc",
  null
  
)

export default component.exports